module.exports = __webpack_public_path__ + "ce4244ddeda488941626d32f10b7c40e.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/components/face/index/images/youzhen_c.png
// module id = 274
// module chunks = 3